var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1783 3.83248C15.8292 3.18161 15.8292 2.12633 15.1783 1.47546C14.5275 0.824586 13.4722 0.824586 12.8213 1.47546L1.15466 13.1421C0.503785 13.793 0.503785 14.8483 1.15466 15.4991L12.8213 27.1658C13.4722 27.8167 14.5275 27.8167 15.1783 27.1658C15.8292 26.5149 15.8292 25.4597 15.1783 24.8088L6.35686 15.9873L25.6665 15.9873C26.587 15.9873 27.3332 15.2411 27.3332 14.3206C27.3332 13.4002 26.587 12.654 25.6665 12.654L6.35686 12.654L15.1783 3.83248Z",
    fill: "#EB5B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.c8c2f6045da97af835a8cb6ba1cd3bfc.svg";
export { ForwardRef as ReactComponent };